import React from 'react';
import injectSheet from 'react-jss';

import { layoutMaxWidth } from '../layouts/const.js';

const styles = {
    section: {
        maxWidth: ({ maxWidth = layoutMaxWidth }) => maxWidth,
        margin: '0 auto',
        padding: ({ padding = '2rem 0'}) => padding
    },
    contents: {
        width: '90%',
        margin: '0 auto'
    }
};

const Section = ({ key = '', classes, className, children }) => {
    return (
        <section
            key={key}
            className={classes.section}>
            <div className={`${classes.contents} ${className}`}>
                {children}
            </div>
        </section>
    );
};

export default injectSheet(styles)(Section);



// WEBPACK FOOTER //
// ./src/components/Section.js